import Tool from '../tool';
import * as constants from '../../constants';
import toggleSolutionButton from '../../shared-ui/toggle-solution-button';

const unitLength = 25;
const gridLength = 12 * unitLength;

let currentQuestion;

const sprite = new PIXI.Sprite();

const titleText = new PIXI.Text('', { font: '18px Open Sans, Arial', fill: 0xFFFFFF });
const grid = new PIXI.Sprite();
const toggleSolutionBtn = toggleSolutionButton();

sprite.addChild(titleText);
sprite.addChild(grid);
sprite.addChild(toggleSolutionBtn);

titleText.y = 10;
grid.y = 80;
toggleSolutionBtn.y = grid.y + gridLength + 10;

titleText.anchor.set(0.5, 0);
titleText.x = constants.screenCentreX;

grid.x = ( constants.screenWidth - gridLength ) / 2;
toggleSolutionBtn.x = ( constants.screenWidth - toggleSolutionBtn.width ) / 2;

const selectionG = new PIXI.Graphics();
const borders = new PIXI.Graphics();
grid.addChild(selectionG);
grid.addChild(borders);

borders.lineStyle(1, constants.grey);
for ( let i = 0; i <= 12; i++ ) {
  borders.moveTo(0, i * unitLength).lineTo(gridLength, i * unitLength); // horizontal line
  borders.moveTo(i * unitLength, 0).lineTo(i * unitLength, gridLength); // vertical line
}
borders.beginFill(constants.grey);
for ( let i = 0; i <= 12; i++ ) {
  for ( let j = 0; j <= 12; j++ ) {
    borders.drawCircle(i * unitLength, j * unitLength, 2);
  }
}
borders.endFill();

grid.hitArea = new PIXI.Rectangle(0, 0, gridLength, gridLength);
grid.cursor = 'pointer';

let startPoint;
let endPoint;

grid.on('pointerdown', e => {
  if ( currentQuestion.isCompleted ) {
    return;
  }
  currentQuestion.answer = null;
  startPoint = gridPointFromEvent(e);
  endPoint = startPoint;
  drawSelection(getSelection());

  grid.on('pointermove', onPointerMove);
  grid.on('pointerup', onPointerUp);
  grid.on('pointerupoutside', onPointerUp);
});

function onPointerMove( e ) {
  endPoint = gridPointFromEvent(e);
  drawSelection(getSelection());
}
function onPointerUp( e ) {
  grid.off('pointermove', onPointerMove);
  grid.off('pointerup', onPointerUp);
  grid.off('pointerupoutside', onPointerUp);

  currentQuestion.answer = getSelection();
  drawSelection(currentQuestion.answer);
  startPoint = null;
  endPoint = null;
}

function drawSelection( sel, colour ) {
  selectionG.clear();

  if ( !sel ) {
    return;
  }

  if ( typeof colour === 'undefined' ) {
    colour = constants.orange;
  }

  const r = new PIXI.Rectangle();
  [ 'x', 'y', 'width', 'height' ].forEach(prop => r[ prop ] = unitLength * sel[ prop ]);
  selectionG.beginFill(colour).drawRect(r.x, r.y, r.width, r.height).endFill();
}

function getSelection() {
  if ( !startPoint || !endPoint ) {
    return null;
  }
  const l = Math.min(startPoint.x, endPoint.x);
  const t = Math.min(startPoint.y, endPoint.y);
  const r = 1 + Math.max(startPoint.x, endPoint.x);
  const b = 1 + Math.max(startPoint.y, endPoint.y);
  
  return new PIXI.Rectangle(l, t, r - l, b - t);
}

function gridPointFromEvent( e ) {
  const coords = grid.toLocal(e.data.global);
  const x = Math.floor(coords.x / unitLength);
  const y = Math.floor(coords.y / unitLength);
  if ( Math.min(x, y) < 0 || 12 <= Math.max(x, y) ) {
    return null;
  }
  return new PIXI.Point(x, y);
}

export default class GridTool extends Tool {
  static init() {
    this._sprite = sprite;
    this.toggleSolutionBtn = toggleSolutionBtn;
  }

  static loadQuestion( question ) {
    super.loadQuestion(question);
    grid.interactive = true;
    currentQuestion = question;
    titleText.text = question.title;
    drawSelection(null);
  }

  static onQuestionComplete( question ) {
    super.onQuestionComplete(question);
    grid.interactive = false;
    this.showUserSolution(question);
  }

  static showCorrectSolution( question ) {
    drawSelection(question.correctSolution(), constants.green);
  }
  static showUserSolution( question ) {
    drawSelection(question.answer, question.result ? constants.green : constants.red);
  }
}
